import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { FC, useState } from 'react';
// import countries from 'services/constants/countries-delivery.json';
import countries from 'services/constants/countries-new.json';
import { Button } from '@mui/material';
import { CountryWithFlag } from 'ui/CountryWithFlag';
import { TCountrySelectProps } from './types';

export const CountrySelect: FC<TCountrySelectProps> = ({ onChange }) => {
	const [search, setSearch] = useState('');

	return (
		<>
			<Box sx={{ width: 300, maxHeight: 500, p: '10px' }}>
				<TextField
					size="small"
					fullWidth
					placeholder="Choose a country"
					inputProps={{
						autoComplete: 'new-password',
					}}
					value={search}
					onChange={(e) => setSearch(e.target.value)}
					sx={{
						'& .MuiInputBase-root': { borderRadius: '12px' },
						'& input': {
							padding: '5px 10px',
							fontSize: '.9rem',
						},
					}}
				/>
				<Box component="div">
					<Box component="div">
						<Button
							onClick={() => onChange('@empty')}
							sx={{
								width: '100%',
								display: 'flex',
								// flexDirection: 'row',
								justifyContent: 'space-between',
								alignItems: 'center',
								color: '#222',
								textTransform: 'none',
								fontWeight: 'bold',
							}}
						>
							Empty
						</Button>
					</Box>

					{countries
						.filter((item) => item.label.toLowerCase().includes(search.toLowerCase()))
						.map((option) => (
							<Box component="div">
								<Button
									onClick={() => onChange(option.code)}
									sx={{
										width: '100%',
										display: 'flex',
										// flexDirection: 'row',
										justifyContent: 'space-between',
										alignItems: 'center',
										color: '#222',
										textTransform: 'none',

										'& > div img': { mr: 2, flexShrink: 0 },
									}}
								>
									<Box>
										{/* <img
											loading="lazy"
											width="20"
											srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
											src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
											alt=""
										/>
										{option.label} */}
										<CountryWithFlag
											countryCode={option.code}
											size="small"
											// sx={{ display: 'flex', gap: 1 }}
										/>
									</Box>
									<Box>{option.code}</Box>
								</Button>
							</Box>
						))}
				</Box>
			</Box>
			{/* <Autocomplete
				sx={{ width: 300, p: '10px' }}
				size="small"
				options={countries}
				onChange={(event, newValue) => {
					if (newValue) onChange(newValue?.code);
				}}
				autoHighlight
				getOptionLabel={(option) => option.label}
				renderOption={(props, option) => (
					<Box component="li" {...props}>
						<Box
							sx={{
								width: '100%',
								display: 'flex',
								// flexDirection: 'row',
								justifyContent: 'space-between',
								alignItems: 'center',

								'& > div img': { mr: 2, flexShrink: 0 },
							}}
						>
							<Box>
								<img
									loading="lazy"
									width="20"
									srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
									src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
									alt=""
								/>
								{option.label}
							</Box>
							<Box>{option.code}</Box>
						</Box>
					</Box>
				)}
				renderInput={(params) => (
					<TextField
						{...params}
						placeholder="Choose a country"
						inputProps={{
							...params.inputProps,
							autoComplete: 'new-password',
						}}
					/>
				)}
			/> */}
		</>
	);
};

interface CountryType {
	code: string;
	label: string;
	phone: string;
	suggested?: boolean;
}

// From https://bitbucket.org/atlassian/atlaskit-mk-2/raw/4ad0e56649c3e6c973e226b7efaeb28cb240ccb0/packages/core/select/src/data/countries.js
